import { useMemo } from 'react';
import { Table, TableProvider, useTableState } from '@optimus-web/core';
import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { PolicyExceptionsFormStepContextProvider } from '../../../../../contexts';
import { PolicyException } from '../../../../../types';
import { getPolicyExceptionsColumns } from './columns';
import { PolicyExceptionsTableHeader } from './PolicyExceptionsTableHeader';

interface PolicyExceptionsTableProps {
    policyExceptions: Array<PolicyException>;
    editable: boolean;
}

export const PolicyExceptionsTable = ({ policyExceptions, editable }: PolicyExceptionsTableProps) => {
    const [tableState, setTableState] = useTableState<PolicyException>();
    const isRequirePaymentDuringOciEnabled = useFeatureFlag(FeatureFlag.requirePaymentDuringOnlineCheckIn);
    const columns = useMemo(() => {
        const cols = getPolicyExceptionsColumns(isRequirePaymentDuringOciEnabled);
        return editable ? cols : cols.filter((col) => col && col.id !== 'actions');
    }, [editable, isRequirePaymentDuringOciEnabled]).filter((col) => col !== null);
    return (
        <TableProvider columns={columns} state={tableState} onStateChange={setTableState} as="div">
            <PolicyExceptionsFormStepContextProvider>
                <PolicyExceptionsTableHeader subTitle={policyExceptions.length} editable={editable} />
            </PolicyExceptionsFormStepContextProvider>
            <Table uniqueRowId="id" data={policyExceptions} amountOfRows={policyExceptions.length} fixedLastColumn />
        </TableProvider>
    );
};
